/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S9_HeadingInputs */

const tr_mesafeli_s9_heading = /** @type {(inputs: Mesafeli_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Yapay Zekâ (AI) Destekli Hizmetler`)
};

const en_mesafeli_s9_heading = /** @type {(inputs: Mesafeli_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Artificial Intelligence (AI) Powered Services`)
};

const de_mesafeli_s9_heading = /** @type {(inputs: Mesafeli_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Durch künstliche Intelligenz (AI) unterstützte Leistungen`)
};

const ru_mesafeli_s9_heading = /** @type {(inputs: Mesafeli_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Услуги с поддержкой искусственного интеллекта (AI)`)
};

/**
* | output |
* | --- |
* | "9. Artificial Intelligence (AI) Powered Services" |
*
* @param {Mesafeli_S9_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s9_heading = /** @type {((inputs?: Mesafeli_S9_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S9_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s9_heading(inputs)
	if (locale === "de") return de_mesafeli_s9_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s9_heading(inputs)
	return tr_mesafeli_s9_heading(inputs)
});